/**
 * Every id should map to one card.
 */
export enum CardId {
    // Resources
    LogCard,
    TreeCard,
    ForestCard,

    BronzeOre,
    SilverOre,
    GoldOre,

    SmallGrain,
    MediumGrain,

    // Actions
    MagicTouch,
    SacrificeHand,

    Draw3Card,

    LoseTurnsSmall,
    LoseTurnsMedium,
    LoseTurnsLarge,

    InstantDamagePlayerSmall,
    InstantDamagePlayerMedium,
    InstantDamagePlayerLarge,

    FreezeMonstersSmall,
    FreezeMonstersMedium,

    // Curses
    InstantDamageSmall,
    InstantDamageMedium,
    InstantDamageLarge,

    DiscardHand,
    ForestFire,
    RodOfAsclepius,


    // Healing
    Bread,
    ChaliceSmall,
    ChaliceMedium,
    ChaliceLarge,


    // Monsters
    Rat,
    Chicken,
    Cow,
    Pig,
    Farmer,
    LandMine,
    Skeleton,
    SkeletonKing,
    Troll,
    Spider,
    Spiderling,
    Dragon ,

    // Tools
    BronzeAxe,
    SilverAxe,
    GoldAxe,

    BronzePickaxe,
    SilverPickaxe,
    GoldPickaxe,

    BronzeScythe,
    SilverScythe,
    GoldScythe,

    // Weapons
    BasicSword,
    BronzeSword,
    SilverSword,
    GoldSword,

    CrackedShield,
    VikingShield,
}